export default __webpack_public_path__ + "static/media/uefal.fcbb76cc.png";